import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_HREF } from "@/lib/contact";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Trust from "@/components/Trust";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import CtaSection from "@/components/CtaSection";
import Contact from "@/components/Contact";
import MapSection from "@/components/MapSection";
import Footer from "@/components/Footer";
import AvisoLegal from "@/components/AvisoLegal";
import PoliticaPrivacidad from "@/components/PoliticaPrivacidad";

const toasterOptions = {
  style: { fontFamily: "'Manrope', sans-serif", fontSize: "14px" },
};

function MainPage() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) target.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trust />
        <Services />
        <WhyChooseUs />
        <CtaSection />
        <Contact />
        <MapSection />
      </main>
      <Footer />
      <a
        href={WHATSAPP_HREF}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="fixed bottom-20 right-5 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 transition-all duration-300 hover:scale-110 group"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-[#1a1a1a] text-white text-xs px-3 py-2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{ fontFamily: "'Manrope', sans-serif" }}>
          ¿Hablamos?
        </span>
      </a>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#f8f6f3]" data-testid="app-root">
        <Toaster position="top-center" richColors toastOptions={toasterOptions} />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
